var map = {
	"./clinical-forms/en.json": 96375,
	"./clinical-forms/pt.json": 31333,
	"./en.json": 9761,
	"./onboarding/en.json": 48383,
	"./onboarding/pt.json": 87888,
	"./pt.json": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70263;